import script from "./ExposicoesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExposicoesPage.vue?vue&type=script&setup=true&lang=js"

import "./ExposicoesPage.vue?vue&type=style&index=0&id=0fa0e76a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa0e76a"]])

export default __exports__